import React, { useState, useEffect } from 'react';
import Validator from 'validatorjs';
import { Row, Col, Button } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

const CuentaPredialForm = (props) => {
  const [data, setData] = useState({});
  const [validator, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  useEffect(() => {
    const { editing } = props;

    if (!!editing) {
      setData({
        ...editing,
      });
    }
  }, [!!props.editing]); // eslint-disable-line

  const handleOnChange = (event) => {
    const data = {
      ...props.data,
      ...event,
    };

    validate(data);

    setData(data);
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    setValidator({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  };

  const getRules = () => {
    return {
      Numero: ['required', 'min:1', 'max:150', 'regex:/^[0-9a-zA-Z]{1,150}?$/'],
    };
  };

  const handleOnAdd = () => {
    props.onAdd(data, {
      name: 'isValidCuentaPredial',
      isValid: validator.isValid,
    });

    setData({});
  };

  const rules = getRules(data);

  return (
    <>
      <Row>
        <Col>
          <FormControl
            type="text"
            label="Número Predial"
            name="Numero"
            placeholder=""
            help=""
            min="1"
            max="150"
            rules={rules.Numero}
            value={data.Numero}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="text-muted">
            Puedes agregar varias Cuentas Prediales usando el botón "Agregar cuenta predial", la lista se mostrará en la
            tabla.
          </p>
        </Col>
      </Row>

      <Row className="pt-2">
        <Col className="text-left">
          <Button
            variant="secondary"
            disabled={!validator.isValid}
            onClick={handleOnAdd}
          >
            Agregar cuenta predial
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default CuentaPredialForm;
